module.exports = {
    THANK_YOU_PAGE: {
        SUCCESS: 'Thank you!',
        ERROR: 'An error occurred...',
        HOME:'Back to home'
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/translations/en/thank.you.page.ts